 import React, { useEffect, useState ,useMemo } from 'react';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import {
  getSubGroups,
  getUserRoles,
  addUserRole,
  updateUserRole,
  deleteUserRole,
} from '../Service/apiService';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../Service/authConfig';

function UserRolePage() {
  const { instance } = useMsal(); // ✅ get the initialized instance

  const [userRoles, setUserRoles] = useState([]);
  const [adUsers, setAdUsers] = useState([]);
  const [subGroups, setSubGroups] = useState([]);
  const [form, setForm] = useState({ email: '', subGroupID: '' });
  const [editId, setEditId] = useState(null);
// Add this inside your component
const [search, setSearch] = useState('');
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5; // change this to suit your layout

// Filter userRoles based on search input
const filteredUserRoles = useMemo(() => {
  return userRoles.filter(role => {
    const user = adUsers.find((u) => u.userPrincipalName === role.email);
    const username = user?.displayName?.toLowerCase() || '';
    const permission = subGroups.find((p) => p.subGroupID === role.subGroupID)?.subGroupName?.toLowerCase() || '';
    return (
      username.includes(search.toLowerCase()) || permission.includes(search.toLowerCase())
    );
  });
}, [search, userRoles, adUsers, subGroups]);

// Paginate
const paginatedUserRoles = useMemo(() => {
  const start = (currentPage - 1) * itemsPerPage;
  return filteredUserRoles.slice(start, start + itemsPerPage);
}, [filteredUserRoles, currentPage]);

const totalPages = Math.ceil(filteredUserRoles.length / itemsPerPage);
  useEffect(() => {
    loadUserRoles();
    loadsubGroups();
    loadAzureADUsers();
  }, []);

  const loadUserRoles = async () => {
    try {
      const data = await getUserRoles();
      
      setUserRoles(data);
    } catch {
      toast.error('Failed to load user roles');
    }
  };

  const loadsubGroups = async () => {
    try {
      const data = await getSubGroups();
      setSubGroups(data);
    } catch {
      toast.error('Failed to load subGroups');
    }
  };

const loadAzureADUsers = async () => {
  try {
    const account = instance.getAllAccounts()[0];
    const response = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    let users = [];
    let url = 'https://graph.microsoft.com/v1.0/users?$top=999';

    while (url) {
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${response.accessToken}`,
        },
      });

      const data = await res.json();
      users = [...users, ...data.value];
      url = data['@odata.nextLink'] || null;
    }

    setAdUsers(users);
  } catch (err) {
    console.error(err);
    toast.error('Failed to load Azure AD users');
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.subGroupID) {
      toast.error('Please select both user and permission');
      return;
    }
    try {
      if (editId) {
        
        await updateUserRole({ userRolesID: editId, ...form });
        toast.success('User role updated');
      } else {
        await addUserRole(form);
        toast.success('User role added');
      }
      setForm({ email: '', subGroupID: '' });
      setEditId(null);
      loadUserRoles();
    } catch {
      toast.error('Error saving user role');
    }
  };

  const handleEdit = (role) => {
    
    setForm({
      email: role.email || '',
      subGroupID: role.subGroupID || '',
    });
    setEditId(role.userRolesID);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await deleteUserRole(id);
        toast.success('Role deleted');
        loadUserRoles();
      } catch {
        toast.error('Delete failed');
      }
    }
  };

  const userOptions = adUsers.map((u) => ({
    value: u.userPrincipalName,
    label: `${u.displayName} (${u.userPrincipalName})`,
  }));

  const SubGroupOptions = subGroups
    .filter((p) => p.assignmentType === 'Restricted')
    .map((p) => ({
      value: p.subGroupID,
      label: p.subGroupName,
    }));

  return (
    <div className="max-w-3xl mx-auto p-8">
      <Toaster position="top-right" />
      <h1 className="text-3xl font-bold mb-6">User Roles / Permission</h1>

      <form onSubmit={handleSubmit} className="mb-8 space-y-4">
        <div>
          <label className="block mb-1 font-semibold">Azure AD User</label>
          <Select
            options={userOptions}
            value={userOptions.find((opt) => opt.value === form.email) || null}
            onChange={(selected) =>
              setForm({ ...form, email: selected ? selected.value : '' })
            }
            placeholder="Search and select user"
            isClearable
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold">Level / Permission</label>
          <Select
            options={SubGroupOptions}
            value={SubGroupOptions.find((opt) => opt.value === form.subGroupID) || null}
            onChange={(selected) =>
              setForm({ ...form, subGroupID: selected ? selected.value : '' })
            }
            placeholder="Select permission"
            isClearable
          />
        </div>

        <div className="flex space-x-4 mt-4">
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            {editId ? 'Update' : 'Add'} Role
          </button>
          {editId && (
            <button
              type="button"
              onClick={() => {
                setForm({ email: '', subGroupID: '' });
                setEditId(null);
              }}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition"
            >
              Cancel
            </button>
          )}
        </div>
      </form>
<input
  type="text"
  placeholder="Search user or permission..."
  value={search}
  onChange={(e) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to page 1 when search changes
  }}
  className="mb-4 border px-4 py-2 rounded w-full"
/>

     <ul className="space-y-4">
  {paginatedUserRoles.map((role) => (
    <li
      key={role.userRolesID}
      className="flex justify-between items-center border p-4 rounded shadow-sm"
    >
      <div>
        <p>
          <strong>User:</strong>{' '}
          {adUsers.find((u) => u.userPrincipalName === role.email)?.displayName ?? 'N/A'}
        </p>
        <p>
          <strong>Permission:</strong>{' '}
          {subGroups.find((p) => p.subGroupID === role.subGroupID)?.subGroupName ?? 'N/A'}
        </p>
      </div>
      <div className="space-x-2">
        <button
          onClick={() => handleEdit(role)}
          className="bg-yellow-400 text-white px-3 py-1 rounded hover:bg-yellow-500"
        >
          Edit
        </button>
        <button
          onClick={() => handleDelete(role.userRolesID)}
          className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
        >
          Delete
        </button>
      </div>
    </li>
  ))}
</ul>
<div className="flex justify-center mt-6 space-x-2">
  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
    <button
      key={page}
      onClick={() => setCurrentPage(page)}
      className={`px-3 py-1 rounded ${page === currentPage ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
    >
      {page}
    </button>
  ))}
</div>

    </div>
  );
}

export default UserRolePage;
